import axios from "axios"
import * as Constants from "../../constants/apis"

export const commonApi = axios.create({
  baseURL: Constants.CODEK_API_URL + Constants.COMMON + Constants.V1,
  withCredentials: true,
})

export const userApi = axios.create({
  baseURL: Constants.CODEK_API_URL + Constants.PLATFORM + Constants.V1,
  withCredentials: true,
})

const errorHandler = (error: any) => {
  const statusCode = error.response ? error.response.status : null

  if (statusCode !== 401) {
    console.error(error)
  }

  return Promise.reject(error)
}

commonApi.interceptors.response.use(undefined, (error) => {
  return errorHandler(error)
})
